import React from 'react';
import usePrintStore from '../../store/printStore';
import colorIcon from '../../assets/icons/colors_drop.png';
import bwIcon from '../../assets/icons/black_drop.png';

interface ColorModeSelectorProps {
  documentId: string;
  isColor: boolean;
}

const ColorModeSelector: React.FC<ColorModeSelectorProps> = ({ documentId, isColor }) => {
  const { updatePrintSettings } = usePrintStore();
  
  const handleColorModeChange = (colorMode: boolean) => {
    updatePrintSettings(documentId, { color: colorMode });
  };
  
  return (
    <div className="mb-3">
      <label className="block mb-1 font-medium text-sm text-gray-700">Print Mode</label>
      <div className="flex space-x-2">
        <button
          type="button"
          onClick={() => handleColorModeChange(false)}
          className={`flex-1 border p-2 rounded flex flex-col items-center transition-colors ${
            !isColor 
              ? 'bg-blue-50 border-blue-300' 
              : 'border-gray-300 hover:bg-gray-50'
          }`}
        >
          <img src={bwIcon} alt="Black & White" className="w-10 h-10 mb-1" />
          <span className="text-xs">Black & White</span>
        </button>
        
        <button
          type="button"
          onClick={() => handleColorModeChange(true)}
          className={`flex-1 border p-2 rounded flex flex-col items-center transition-colors ${
            isColor 
              ? 'bg-blue-50 border-blue-300' 
              : 'border-gray-300 hover:bg-gray-50'
          }`}
        >
          <img src={colorIcon} alt="Color" className="w-10 h-10 mb-1" />
          <span className="text-xs">Color</span>
        </button>
      </div>
    </div>
  );
};

export default ColorModeSelector;
